<template>
  <div class="next-step">
    <h3 class="next-step__title">Next Step</h3>
    <div class="next-step__msg" v-html="nextStepText" />
    <div v-if="shouldShowSerialNumber">
      <br />
      Serial number:
      <a
        :href="pdfSrc"
        target="_blank"
        v-html="currentUserProfile.application.serialNumber"
      />
      <br />
      <br />
    </div>
    <a class="next-step__link" href="#" @click.prevent="viewInTimeline">
      View in timeline <i class="arrow right"></i>
    </a>
  </div>
</template>


<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'NextStep',
  computed: {
    ...mapGetters([
      'allTasks',
      'currentUserProfile',
    ]),
    ...mapState([
      'shouldShowSerialNumber',
      'pdfSrc',
    ]),
    data() {
      return {
        pdfSrc: null
      }
    },
    nextStepText() {
      const found = this.allTasks.find(m => m.step === this.currentUserProfile?.timelineStep)
      if (!found) {
        return '';
      }
      let text = found.text
      if (found.details) {
        text += `</p><p>${found.details}`
      }
      return text
    },
    shouldShowSerialNumber() {
      return this.currentUserProfile?.application?.serialNumber && this.pdfSrc
    },
  },
  methods: {
    viewInTimeline() {
      this.$smoothScroll({
        scrollTo: document.querySelector(`#task-${this.currentUserProfile?.timelineStep + 1}`),
        offset: -150
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.next-step {
  border: solid 1px #ccc;
  max-width: 40rem;
  width: 100%;
  margin: 2rem auto;
  background: $light;
  @media ($sm-down) {
    max-width: 90%;
  }
  &__title {
    font-size: 1rem;
    padding: 0.5rem 2rem;
    background: $secondary;
    color: #fff;
  }
  &__msg {
    font-size: 1.3rem;
    padding: 1rem 2rem .5rem;
  }
  > div {
    max-width: 38rem;
    margin: 0 auto;
  }
  &__link {
    display: block;
    padding: 0 0 1rem;
    margin: .5rem 0 0;
  }
}
</style>